import { makeStyles } from '@mui/styles';

const styles = (theme) => {
  return {
    toolBar: {
      height: '10vh',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '20px',
      backgroundColor: 'white',
    },
    logo: {
      color: 'blue',
      cursor: 'pointer',
    },
    link: {
      color: "#000"
    },
    menuIcon: {
      color: '#000',
    },
    formContainer: {
      flexGrow: 1,
      padding: '10px',
      maxWidth: '700px',
      margin: '30px auto',
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
      },
    },
    form: {
      marginTop: '30px',
    },
    formHeading: {
      textAlign: 'center',
    },
    heroBox: {
      width: '100%',
      position: 'relative',
      display: 'flex',
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      overflowX: 'hidden',
      overflowY: 'visible',
      [theme.breakpoints.down('md')]: {
        minHeight: '800px',
        paddingTop: '60px',
      },
    },
    gridContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      maxWidth: '1440px',
      width: '100%',
      padding: '120px 60px 60px 60px',
      position: 'relative',
      zIndex: 2,
      overflow: 'visible',
      [theme.breakpoints.down('md')]: {
        padding: '100px 40px 40px 40px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '80px 20px 40px 20px',
      },
    },
    aboutUsContainer: {
      width: '100%',
      display: 'flex',
      minHeight: '420px',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0',
      padding: '56px 40px 72px',
      backgroundColor: '#FFFFFF',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        padding: '40px 20px 56px',
      },
    },
    aboutLayout: {
      display: 'flex',
      alignItems: 'stretch',
      gap: '48px',
      maxWidth: '1180px',
      width: '100%',
      position: 'relative',
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: '32px',
      },
    },
    aboutImageCol: {
      flex: '1 1 48%',
      minWidth: 0,
    },
    aboutImageWrap: {
      position: 'relative',
      width: '100%',
      height: '100%',
      minHeight: '420px',
      borderRadius: '22px',
      overflow: 'hidden',
      boxShadow: '0 18px 40px rgba(26, 15, 59, 0.14)',
      [theme.breakpoints.down('sm')]: {
        minHeight: '280px',
      },
    },
    aboutImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    aboutImageOverlay: {
      position: 'absolute',
      left: '22px',
      bottom: '22px',
      maxWidth: '80%',
      zIndex: 2,
    },
    aboutImageCaption: {
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '1.05rem',
      fontWeight: 800,
      color: '#FFFFFF',
      letterSpacing: '1.2px',
      textTransform: 'uppercase',
      lineHeight: 1.25,
      textShadow: '0 2px 12px rgba(0,0,0,0.45)',
      marginBottom: '8px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },
    },
    aboutImageCaptionLine: {
      width: '56px',
      height: '4px',
      borderRadius: '3px',
      background: 'linear-gradient(90deg, #6411ED, #7628FF)',
      boxShadow: '0 0 10px rgba(118, 40, 255, 0.5)',
    },
    aboutContentCol: {
      flex: '1 1 44%',
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '12px 48px 28px 8px',
      [theme.breakpoints.down('md')]: {
        padding: '0 8px 24px',
      },
    },
    aboutEyebrow: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: '2.4px',
      textTransform: 'uppercase',
      color: '#6411ED',
      marginBottom: '12px',
    },
    aboutTitle: {
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '2.6rem',
      fontWeight: 800,
      color: '#111827',
      lineHeight: 1.15,
      margin: '0 0 16px',
      letterSpacing: '-0.4px',
      '& span': {
        background: 'linear-gradient(105deg, #6411ED 0%, #7628FF 55%, #9F5CFF 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '2rem',
      },
    },
    aboutBody: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '15.5px',
      fontWeight: 400,
      color: '#1F2937',
      lineHeight: 1.65,
      maxWidth: '460px',
      marginBottom: '28px',
      opacity: 1,
      paddingBottom: 0,
    },
    aboutStoreRow: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '36px',
    },
    aboutStoreLink: {
      display: 'inline-flex',
      lineHeight: 0,
      transition: 'transform 0.2s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
      },
    },
    aboutStoreBadge: {
      height: '44px',
      width: 'auto',
      display: 'block',
    },
    aboutDecor: {
      position: 'absolute',
      top: '8px',
      right: '-8px',
      width: '90px',
      height: '260px',
      pointerEvents: 'none',
      color: 'rgba(118, 40, 255, 0.28)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    aboutPin: {
      fontSize: '42px !important',
      color: '#7628FF !important',
      filter: 'drop-shadow(0 4px 10px rgba(100, 17, 237, 0.35))',
      marginBottom: '-4px',
    },
    aboutRoute: {
      width: '70px',
      height: '200px',
      color: 'rgba(118, 40, 255, 0.32)',
    },
    aboutFooterTag: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginTop: 'auto',
      alignSelf: 'flex-end',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '1.8px',
      textTransform: 'uppercase',
      color: '#1A0F3B',
      [theme.breakpoints.down('sm')]: {
        alignSelf: 'flex-start',
        marginTop: '8px',
      },
    },
    aboutFooterLine: {
      width: '42px',
      height: '3px',
      borderRadius: '2px',
      background: 'linear-gradient(90deg, #6411ED, #7628FF)',
    },
    aboutUsSubtitle: {
      opacity: '0.7',
      paddingBottom: '30px',
      fontSize: '18px',
    },
    heroKicker: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
      color: '#d1d5db',
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: '3.5px',
      textTransform: 'uppercase',
      marginBottom: '20px',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      lineHeight: 1.4,
    },
    heroKickerLine: {
      width: '28px',
      height: '2.5px',
      background: 'linear-gradient(90deg, #c084fc, #9333ea)',
      borderRadius: '2px',
      boxShadow: '0 0 8px rgba(168, 85, 247, 0.7)',
    },
    heroTitleWhite: {
      color: '#FFFFFF',
      fontSize: '4.5rem',
      fontWeight: 800,
      lineHeight: 0.95,
      letterSpacing: '-0.5px',
      margin: 0,
      marginBottom: '-6px',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
      [theme.breakpoints.down('md')]: {
        fontSize: '3.3rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '2.4rem',
      },
    },
    heroTitlePurpleWrap: {
      position: 'relative',
      display: 'block',
      margin: '-10px 0 8px 0',
      paddingBottom: '12px',
      overflow: 'visible',
    },
    heroTitlePurple: {
      background: 'linear-gradient(180deg, #f5d0fe 0%, #e9d5ff 20%, #c084fc 50%, #a855f7 75%, #7e22ce 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontSize: '5.8rem',
      fontWeight: 800,
      fontStyle: 'italic',
      lineHeight: 1.05,
      letterSpacing: '-0.5px',
      display: 'inline-block',
      paddingBottom: '8px',
      paddingRight: '8px',
      textTransform: 'lowercase',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      filter: 'none !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '4.6rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '3.4rem',
      },
    },
    titleMain: {
      marginTop:'70px',
      paddingBottom: '10px',
      color: '#fff'
    },
    title: {
      paddingBottom: '15px'
    },
    subtitleMain: {
      color: 'rgba(255, 255, 255, 0.88)',
      fontSize: '15px',
      lineHeight: 1.7,
      maxWidth: '480px',
      margin: '4px 0 20px 0',
      textShadow: '0 1px 4px rgba(0,0,0,0.6)',
      fontWeight: 400,
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      }
    },
    heroCtaBtn: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '18px',
      marginTop: '24px',
      padding: '8px 8px 8px 32px !important',
      borderRadius: '999px !important',
      background: 'linear-gradient(90deg, #9333ea 0%, #7c3aed 50%, #a855f7 100%) !important',
      color: '#FFFFFF !important',
      boxShadow: '0 0 28px rgba(168, 85, 247, 0.75), 0 4px 18px rgba(124, 58, 237, 0.5) !important',
      textTransform: 'uppercase',
      fontWeight: '700 !important',
      fontSize: '16px !important',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      letterSpacing: '1px !important',
      border: '1px solid rgba(255, 255, 255, 0.3) !important',
      cursor: 'pointer',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important',
      '&:hover': {
        background: 'linear-gradient(90deg, #a855f7 0%, #9333ea 50%, #c084fc 100%) !important',
        transform: 'translateY(-2px) scale(1.03)',
        boxShadow: '0 0 38px rgba(192, 132, 252, 0.9), 0 6px 22px rgba(147, 51, 234, 0.6) !important',
      }
    },
    heroArrowCircle: {
      width: '38px',
      height: '38px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.18)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FFFFFF',
      transition: 'transform 0.3s ease',
      '$heroCtaBtn:hover &': {
        transform: 'translateX(3px)',
        backgroundColor: 'rgba(255, 255, 255, 0.28)',
      }
    },
    floatingSloganBox: {
      position: 'absolute',
      right: '7%',
      top: '16%',
      zIndex: 3,
      textAlign: 'left',
      maxWidth: '190px',
      pointerEvents: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      }
    },
    floatingSloganWhite: {
      color: '#FFFFFF',
      fontSize: '23px',
      fontWeight: 600,
      lineHeight: 1.22,
      letterSpacing: '-0.3px',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      textShadow: '0 2px 10px rgba(0, 0, 0, 0.8)',
    },
    floatingSloganPurple: {
      background: 'linear-gradient(135deg, #f0abfc 0%, #c084fc 50%, #a855f7 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 800,
      fontSize: '27px',
      display: 'inline-block',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      filter: 'drop-shadow(0 0 12px rgba(168, 85, 247, 0.7))',
    },
    qrBadgeContainer: {
      position: 'absolute',
      bottom: '36px',
      right: '5%',
      zIndex: 3,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '8px 16px',
      borderRadius: '12px',
      backgroundColor: 'rgba(15, 7, 28, 0.75)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(168, 85, 247, 0.4)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5), 0 0 18px rgba(147, 51, 234, 0.25)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        borderColor: 'rgba(192, 132, 252, 0.7)',
        boxShadow: '0 4px 25px rgba(168, 85, 247, 0.45)',
        transform: 'translateY(-2px)',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      }
    },
    qrBadgeText: {
      color: '#FFFFFF',
      fontSize: '13px',
      fontWeight: 600,
      letterSpacing: '0.3px',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    },
    qrBadgeIcon: {
      fontSize: '26px',
      background: '#FFFFFF',
      color: '#0f071c !important',
      borderRadius: '4px',
      padding: '2px',
    },
    subtitle: {
      opacity: '0.4',
      paddingBottom: '30px'
    },
    largeImage: {
      width: '100%',
    },
    sectionGridContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    },
    sectionGridItem: {
      padding: '50px',
      width: '200px',
      borderRadius: '10px',
      margin: '10px !important',
    },
    sectionGridItem1: {
      width: '550px',
      borderRadius: '10px',
      padding: '10px',
    },
    vehicleSection: {
      width: '100%',
      padding: '48px 20px 64px',
      backgroundColor: '#FBFAFE',
      backgroundImage:
        'repeating-linear-gradient(135deg, rgba(100,17,237,0.04) 0px, rgba(100,17,237,0.04) 2px, transparent 2px, transparent 18px), linear-gradient(180deg, #FBFAFE 0%, #F4F2FE 55%, #EBE7FB 100%)',
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        padding: '32px 16px 48px',
      },
    },
    vehicleSectionTopRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      maxWidth: '1280px',
      margin: '0 auto 8px',
      gap: '16px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    vehicleSideLabel: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '1.6px',
      color: '#1A0F3B',
      textTransform: 'uppercase',
    },
    vehicleSideLabelRight: {
      textAlign: 'right',
    },
    vehicleSideUnderline: {
      width: '54px',
      height: '3px',
      borderRadius: '2px',
      marginTop: '6px',
      background: 'linear-gradient(90deg, #6411ED, #7628FF)',
    },
    vehicleSectionTitle: {
      textAlign: 'center',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '2.35rem',
      fontWeight: 800,
      color: '#111827',
      margin: '8px 0 10px',
      letterSpacing: '-0.4px',
      '& span': {
        color: '#6411ED',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.7rem',
      },
    },
    vehicleSectionSubtitle: {
      textAlign: 'center',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '15px',
      color: '#766293',
      maxWidth: '560px',
      margin: '0 auto 28px',
      lineHeight: 1.5,
    },
    vehicleCardsRow: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: '12px',
      maxWidth: '1280px',
      margin: '0 auto',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    vehicleCard: {
      position: 'relative',
      flex: '1 1 0',
      minWidth: 0,
      width: '20%',
      maxWidth: 'none',
      background: 'linear-gradient(180deg, #FFFFFF 0%, #F4F2FE 100%)',
      border: '1px solid #D7CFEB',
      borderRadius: '18px',
      boxShadow: '0 10px 28px rgba(26, 15, 59, 0.08)',
      padding: '16px 10px 14px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 100%',
        width: '100%',
        maxWidth: '320px',
      },
    },
    vehicleWomenBadge: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '3px',
      background: 'linear-gradient(90deg, #EC4899, #F472B6)',
      color: '#FFFFFF',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '10px',
      fontWeight: 700,
      borderRadius: '999px',
      padding: '3px 8px',
      zIndex: 2,
      boxShadow: '0 4px 12px rgba(236, 72, 153, 0.35)',
    },
    vehicleImageWrap: {
      width: '100%',
      height: '88px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '8px',
    },
    vehicleImage: {
      maxWidth: '100%',
      maxHeight: '80px',
      objectFit: 'contain',
    },
    vehicleName: {
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '1.05rem',
      fontWeight: 800,
      color: '#111827',
      marginBottom: '6px',
    },
    vehicleDesc: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '11.5px',
      color: '#766293',
      lineHeight: 1.4,
      minHeight: '48px',
      marginBottom: '8px',
    },
    vehiclePrice: {
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '1.1rem',
      fontWeight: 800,
      color: '#6411ED',
      marginBottom: '4px',
      '& span': {
        fontSize: '0.78rem',
        fontWeight: 600,
      },
    },
    vehicleMeta: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '10.5px',
      color: '#766293',
      lineHeight: 1.35,
      marginBottom: '2px',
    },
    vehicleInfoBtn: {
      marginTop: '12px !important',
      width: '100%',
      minHeight: '40px',
      borderRadius: '12px !important',
      textTransform: 'uppercase !important',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontWeight: '700 !important',
      fontSize: '11px !important',
      letterSpacing: '0.4px',
      color: '#FFFFFF !important',
      position: 'relative',
      overflow: 'hidden',
      isolation: 'isolate',
      /* Brand metallic sweep (same stops as mobile BRAND_GRADIENT) */
      background:
        'linear-gradient(105deg, #2C195B 0%, #46159D 22%, #6411ED 48%, #7628FF 72%, #3B2275 100%) !important',
      boxShadow:
        '0 6px 16px rgba(100, 17, 237, 0.35), inset 0 1px 0 rgba(255,255,255,0.32), inset 0 -2px 8px rgba(10,6,24,0.28) !important',
      border: '1px solid rgba(118, 40, 255, 0.45) !important',
      display: 'inline-flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      /* Soft top gloss for metal finish */
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '46%',
        background:
          'linear-gradient(180deg, rgba(251,250,254,0.34) 0%, rgba(251,250,254,0.08) 70%, rgba(251,250,254,0) 100%)',
        pointerEvents: 'none',
        zIndex: 0,
        borderRadius: '11px 11px 40% 40%',
      },
      '& > *': {
        position: 'relative',
        zIndex: 1,
      },
      '&:hover': {
        background:
          'linear-gradient(105deg, #221448 0%, #3B2275 22%, #5B0FD9 48%, #6D1FF0 72%, #2C195B 100%) !important',
        boxShadow:
          '0 8px 20px rgba(100, 17, 237, 0.42), inset 0 1px 0 rgba(255,255,255,0.38), inset 0 -2px 8px rgba(10,6,24,0.3) !important',
      },
    },
    vehicleInfoArrow: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      background:
        'linear-gradient(145deg, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.12) 55%, rgba(10,6,24,0.2) 100%)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    featuresSection: {
      width: '100%',
      flexGrow: 1,
      minHeight: '420px',
      padding: '56px 40px 72px',
      boxSizing: 'border-box',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        padding: '40px 20px 56px',
      },
    },
    featuresTitle: {
      textAlign: 'center',
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '2.4rem',
      fontWeight: 800,
      color: '#FFFFFF',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      margin: '0 0 10px',
      textShadow: '0 2px 18px rgba(0,0,0,0.35)',
      '& span': {
        color: '#7628FF',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.65rem',
      },
    },
    featuresSubtitle: {
      textAlign: 'center',
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '13px',
      fontWeight: 600,
      color: '#FBFAFE',
      letterSpacing: '2.4px',
      textTransform: 'uppercase',
      margin: '0 auto 10px',
      opacity: 0.95,
    },
    featuresUnderline: {
      width: '72px',
      height: '4px',
      borderRadius: '3px',
      margin: '0 auto 40px',
      background: 'linear-gradient(90deg, #6411ED, #7628FF)',
      boxShadow: '0 0 14px rgba(118, 40, 255, 0.55)',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '36px 48px',
      maxWidth: '1080px',
      margin: '0 auto',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        gap: '28px',
      },
    },
    featureItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '18px',
    },
    featureIconBox: {
      flexShrink: 0,
      width: '64px',
      height: '64px',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(44, 25, 91, 0.55)',
      border: '1.5px solid rgba(118, 40, 255, 0.65)',
      boxShadow:
        '0 0 18px rgba(100, 17, 237, 0.45), inset 0 1px 0 rgba(255,255,255,0.12)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
    },
    featureIcon: {
      fontSize: '30px !important',
      color: '#FBFAFE !important',
    },
    featureCopy: {
      flex: 1,
      minWidth: 0,
      paddingTop: '2px',
    },
    featureTitle: {
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: '1.35rem',
      fontWeight: 800,
      color: '#FFFFFF',
      marginBottom: '8px',
      lineHeight: 1.2,
      textShadow: '0 1px 8px rgba(0,0,0,0.25)',
    },
    featureText: {
      fontFamily: "'Outfit', 'Poppins', sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(251, 250, 254, 0.92)',
      lineHeight: 1.55,
    },
    inputField: {
      marginBottom: '20px !important',
    },
    textArea: {
      width: '100%',
      marginBottom: '20px',
      fontSize: '16px',
      padding: '10px',
    },
    footerContainer: {
      display: 'flex',
      alignItems: 'center',
      miHeight: '10vh',
      padding: '20px',
      justifyContent: 'center',
      backgroundColor: '#f2f0f1',
      flexDirection: 'column',
    },
    footerText: {
      paddingBottom: '10px',
    },
    footerDate: {
      opacity: '0.4',
    },
    testimonialCard: {
      backgroundColor: '#fff',
      padding: '10px',
      minHeight: '200px',
      display: 'flex',
      alignItems: 'center',
    },
    testimonialStatement: {
      paddingBottom: '25px',
    },
    avatar: {
      marginRight: '10px',
    },
    testimonialPosition: {
      fontSize: '14px',
      opacity: '0.6',
    },
  };
};

const useStyles = makeStyles(styles);
export default useStyles;